const fr = {
  // Navigation
  nav: {
    dashboard: "Tableau de bord",
    produits: "Créer un Produit",
    stock: "État du Stock",
    fournisseurs: "Créer un Fournisseur",
    bonsCommande: "Approvisionnement / Commande",
    vendeurs: "Vendeurs/Rabateurs",
    ventes: "Ventes magasin",
    commandes: "Vente en Ligne",
    caisse: "Caisse",
    rapports: "Rapports",
    journalVentes: "Journal des ventes",
    parametres: "Paramètres",
    utilisateurs: "Utilisateurs",
    activite: "Activité du compte",
    abonnement: "Mon abonnement",
    monEntreprise: "Mon entreprise",
    devis: "Devis",
    commandesClient: "Commandes clients",
    retoursClients: "Retours clients",
    inventaires: "Inventaires",
    reappro: "Réapprovisionnement",
    prix: "Prix & Promotions",
    taxes: "Taxes",
    deconnexion: "Déconnexion",
  },
  // Auth
  auth: {
    connexion: "Connexion",
    email: "Email",
    motDePasse: "Mot de passe",
    seConnecter: "Se connecter",
    deconnexion: "Déconnexion",
    bienvenue: "Bienvenue",
    gestionCommerce: "Gestion de votre commerce",
    identifiantsIncorrects: "Identifiants incorrects",
    chargement: "Connexion en cours...",
  },
  // Commun
  commun: {
    ajouter: "Ajouter",
    modifier: "Modifier",
    supprimer: "Supprimer",
    annuler: "Annuler",
    enregistrer: "Enregistrer",
    confirmer: "Confirmer",
    rechercher: "Rechercher",
    filtrer: "Filtrer",
    exporter: "Exporter",
    imprimer: "Imprimer",
    fermer: "Fermer",
    oui: "Oui",
    non: "Non",
    actif: "Actif",
    inactif: "Inactif",
    total: "Total",
    date: "Date",
    statut: "Statut",
    actions: "Actions",
    chargement: "Chargement...",
    aucunResultat: "Aucun résultat",
    erreurServeur: "Erreur serveur, réessayez",
    succes: "Opération réussie",
    devise: "GNF",
    tous: "Tous",
  },
  // Dashboard
  dashboard: {
    titre: "Tableau de bord du jour",
    ventesMagasin: "Ventes magasin",
    ventesVendeurs: "Vendeurs/Rabateurs terrain",
    ventesLivraison: "Vente en Ligne",
    totalEncaisse: "Total encaissé",
    beneficeBrut: "Bénéfice brut",
    articlesVendus: "Articles vendus",
    commandesEnAttente: "Commandes en attente",
    ecartsVendeurs: "Écarts vendeurs/rabateurs",
    clotureJournee: "Clôturer la journée",
    stockAlerte: "Alertes stock",
    vendeurActifs: "Vendeurs actifs aujourd'hui",
  },
  // Produits
  produits: {
    titre: "Catalogue produits",
    ajouterProduit: "Ajouter un produit",
    nom: "Nom du produit",
    categorie: "Catégorie",
    valise: "Valise",
    sac: "Sac",
    modele: "Modèle",
    taille: "Taille",
    couleur: "Couleur",
    codeVariante: "Code variante",
    prixVenteMagasin: "Prix vente magasin",
    prixVenteLivraison: "Prix vente livraison",
    prixAchat: "Prix d'achat",
    description: "Description",
    photos: "Photos",
    variantes: "Variantes",
    ajouterVariante: "Ajouter une variante",
    stockDisponible: "Stock disponible",
    stockFaible: "Stock faible",
    rupture: "Rupture de stock",
  },
  // Stock
  stock: {
    titre: "Gestion du stock",
    mouvements: "Mouvements de stock",
    quantiteDisponible: "Disponible",
    quantiteReservee: "Réservé",
    seuilAlerte: "Seuil d'alerte",
    alerteStock: "⚠️ Stock faible",
    ajustement: "Ajustement manuel",
    historique: "Historique",
    entree: "Entrée",
    sortie: "Sortie",
    canal: "Canal",
    magasin: "Magasin",
    terrain: "Terrain",
    livraison: "Livraison",
    approvisionnement: "Approvisionnement",
  },
  // Fournisseurs
  fournisseurs: {
    titre: "Fournisseurs",
    ajouterFournisseur: "Ajouter un fournisseur",
    nom: "Nom du fournisseur",
    telephone: "Téléphone",
    adresse: "Adresse",
    specialite: "Spécialité",
    valises: "Valises",
    sacs: "Sacs",
    mixte: "Mixte",
    approvisionnements: "Approvisionnements",
    nouvelApprovisionnement: "Nouvel approvisionnement",
    coutTotal: "Coût total",
    comparerPrix: "Comparer les prix",
  },
  // Vendeurs
  vendeurs: {
    titre: "Vendeurs/Rabateurs journaliers",
    ajouterVendeur: "Ajouter un vendeur",
    sortieMatin: "Sortie du matin",
    retourSoir: "Retour du soir",
    articleConfies: "Articles confiés",
    articlesRetournes: "Articles retournés",
    montantAttendu: "Montant attendu",
    montantRemis: "Montant remis",
    ecart: "Écart",
    dette: "Dette",
    solde: "Solde dette",
    rembourser: "Enregistrer remboursement",
    bonSortie: "Bon de sortie",
    alerteEcart: "⚠️ Écart détecté",
    sortieDejaouverte: "Ce vendeur a déjà une sortie ouverte aujourd'hui",
  },
  // Ventes magasin
  ventes: {
    titre: "Ventes en magasin",
    nouvelleVente: "Nouvelle vente",
    produitsVendus: "Produits vendus",
    modePaiement: "Mode de paiement",
    especes: "Espèces",
    orangeMoney: "Orange Money",
    mtnMoney: "MTN Money",
    autre: "Autre",
    ticket: "Ticket de caisse",
    histoiqueVentes: "Historique des ventes",
    venteDuJour: "Ventes du jour",
  },
  // Commandes en ligne
  commandes: {
    titre: "Commandes en ligne",
    nouvelleCommande: "Nouvelle commande",
    client: "Client",
    telephone: "Téléphone",
    adresseLivraison: "Adresse de livraison",
    quartier: "Quartier",
    fraisLivraison: "Frais de livraison",
    noteLivraison: "Note livraison (moto-taxi, etc.)",
    statut: {
      en_attente: "En attente",
      confirmee: "Confirmée",
      en_livraison: "En livraison",
      livree: "Livrée",
      annulee: "Annulée",
    },
    changerStatut: "Changer le statut",
    facture: "Facture de livraison",
  },
  // Caisse
  caisse: {
    titre: "Caisse",
    solde: "Solde actuel",
    entrees: "Entrées",
    sorties: "Sorties",
    ajouterDepense: "Ajouter une dépense",
    depenseDiverse: "Dépense diverse",
    description: "Description",
    montant: "Montant",
    filtrerParCanal: "Filtrer par canal",
    filtrerParDate: "Filtrer par date",
  },
  // Rapports
  rapports: {
    titre: "Rapports et statistiques",
    chiffreAffaires: "Chiffre d'affaires",
    beneficeNet: "Bénéfice net",
    produitsLesPlusVendus: "Produits les plus vendus",
    performanceVendeurs: "Performance des vendeurs",
    comparaisonFournisseurs: "Comparaison fournisseurs",
    tauxLivraison: "Taux de livraison",
    periode: "Période",
    exportPDF: "Exporter PDF",
    exportExcel: "Exporter Excel",
  },
  // Rôles (lot L03 SaaS : 'employe' renommé 'gerant_vendeur' ;
  // alias legacy 'employe' conservé pour rétro-compat).
  roles: {
    admin: "Admin",
    superadmin: "Super Admin",
    proprietaire: "Propriétaire",
    gerant_vendeur: "Gérant/Vendeur",
    employe: "Gérant/Vendeur",
    vendeur: "Vendeur terrain",
    consultation: "Consultation",
  },
};

export default fr;
